import { render, staticRenderFns } from "./DeleteTasksDialog.vue?vue&type=template&id=28504522&scoped=true"
import script from "./DeleteTasksDialog.vue?vue&type=script&lang=js"
export * from "./DeleteTasksDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteTasksDialog.vue?vue&type=style&index=0&id=28504522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28504522",
  null
  
)

export default component.exports